import React, { useState } from 'react';

interface bannerProps {
  message: string
  isDisplayed: boolean
}

const SHOW_BANNER = false; // Change to true to enable the banner

  
const NewsBanner = (props: bannerProps) => {
  const [newsBanner, setNewsBanner] = useState(props.isDisplayed)
  
  return null;
  
    if (!SHOW_BANNER) return null;

  return (
    newsBanner ?
      (<div className="d-flex justify-content-between align-items-center px-2 py-1 bg-primary-light">
        <span className="text-black fs-5"><strong>Important Notice:</strong> {props.message}
        </span>
        <a onClick={() => setNewsBanner(false)} href="#" className="text-black fs-5 fw-bold no-underline-link mx-1">X</a>
      </div>
      ) : (
        null)
  )
}

export default NewsBanner